import React, { useState } from 'react';
import './Vault.css';

const Vault = () => {
  const [selectedEnvelope, setSelectedEnvelope] = useState(null);

  const envelopes = [
    { 
      id: 1, 
      title: "Open when... you're sad", 
      emoji: "🥺", 
      content: "Whenever you feel down, remember that you are the strongest person I know. Take a deep breath. I'm always in your corner.",
      image: "" // Replace with a cute photo
    },
    { 
      id: 2, 
      title: "Open when... you miss me", 
      emoji: "🫂", 
      content: "I'm probably missing you more! Close your eyes and imagine a huge hug. I'll see you soon, my love.",
      image: "https://res.cloudinary.com/dbwhboqfx/image/upload/v1780524815/WhatsApp_Image_2026-06-04_at_02.13.08_eadetk.jpg" 
    },
    { 
      id: 3, 
      title: "Open when... you need a laugh", 
      emoji: "😂", 
      content: "Remember that time we tried to cook that fancy dinner and ended up ordering pizza at 11 PM? We're a mess, but we're a fun mess.",
      image: "" 
    },
    { 
      id: 4, 
      title: "Open when... you're stressed", 
      emoji: "🧘‍♀️", 
      content: "Stop. Put your phone down. Go get a glass of water. You've got this, and everything is going to be okay.",
      image: "" 
    },
    { 
      id: 5, 
      title: "Open when... you're proud", 
      emoji: "🌟", 
      content: "I knew you could do it! I never doubted you for a second. Let's celebrate tonight!",
      image: "" 
    },
    { 
      id: 6, 
      title: "Open when... it's late at night", 
      emoji: "🌙", 
      content: "Get some sleep, sleepyhead. I'll be the first person you talk to in the morning. Sweet dreams.",
      image: "" 
    },
  ];

  return (
    <div className="vault-container">
      <div className="vault-header">
        <h1>Digital Envelopes ✉️</h1>
        <p>A little something for every mood.</p>
      </div>

      <div className="envelope-grid">
        {envelopes.map((env) => (
          <div key={env.id} className="envelope-item" onClick={() => setSelectedEnvelope(env)}>
            <div className="envelope-icon">{env.emoji}</div>
            <h3>{env.title}</h3>
          </div>
        ))}
      </div>

      {/* MODAL POPUP */}
      {selectedEnvelope && (
        <div className="vault-modal-overlay" onClick={() => setSelectedEnvelope(null)}>
          <div className="vault-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-vault" onClick={() => setSelectedEnvelope(null)}>&times;</button>
            <div className="modal-emoji">{selectedEnvelope.emoji}</div>
            <h2>{selectedEnvelope.title}</h2>
            <p className="modal-text">{selectedEnvelope.content}</p>
            {selectedEnvelope.image && <img src={selectedEnvelope.image} alt="Memory" className="modal-img" />}
          </div>
        </div>
      )}
    </div>
  );
};

export default Vault;